import React from 'react'
import './intro.css'

// Each export renders its tag (or `as`) with its intro.css class added to the caller's className.
const motion = (tag, name) => ({ as: Tag = tag, className, ...props }) =>
  <Tag className={className ? `${name} ${className}` : name} {...props}/>

export const Stage = motion('main', 'intro-stage')
export const Scene = motion('div', 'intro-scene')
export const Skip = motion('button', 'intro-skip')

export const Rise = motion('div', 'intro-rise')
export const Pop = motion('div', 'intro-pop')
export const Deal = motion('div', 'intro-deal')
export const FadeIn = motion('span', 'intro-fade-in')
export const FadeOut = motion('span', 'intro-fade-out')

export const Picked = motion('div', 'intro-picked')
export const Dimmed = motion('li', 'intro-dimmed')
export const Winner = motion('li', 'intro-winner')

export const ChipOn = motion('span', 'intro-chip-on')
export const ChipOff = motion('span', 'intro-chip-off')

export const Slot = motion('span', 'intro-slot')
export const Fan = motion('div', 'intro-fan')
export const FanCard = ({ $dark, ...props }) =>
  <div className={$dark ? 'intro-fan-card intro-fan-card-dark' : 'intro-fan-card'} {...props}/>
export const Tally = motion('div', 'intro-tally')
export const Fatality = motion('div', 'intro-fatality')

export const Confetti = ({ $x, $y, $r, $c, $round, ...props }) => <span className="intro-confetti" style={{
  top: `${$y}%`, left: `${$x}%`, width: $round ? 14 : 44, background: $c, transform: `rotate(${$r || 0}deg)`,
}} {...props}/>

export const Dots = motion('div', 'intro-dots')
